import { createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, resolveComponent as _resolveComponent, withCtx as _withCtx, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-8b3af890")

_pushScopeId("data-v-8b3af890")
const _hoisted_1 = /*#__PURE__*/_createVNode("div", { class: "labels" }, [
  /*#__PURE__*/_createVNode("div", { class: "label" }, "From*"),
  /*#__PURE__*/_createVNode("div", { class: "label pl-4" }, "To*")
], -1)
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_period_picker = _resolveComponent("period-picker")
  const _component_smooth_reflow = _resolveComponent("smooth-reflow")

  return (_openBlock(), _createBlock("div", null, [
    _hoisted_1,
    _createVNode(_component_smooth_reflow, { options: { property: 'height', transition: 'height 0.2s' } }, {
      default: _withId(() => [
        (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.periods, (period) => {
          return (_openBlock(), _createBlock(_component_period_picker, {
            key: period.id,
            onRemove: ($event: any) => (_ctx.removePeriod(period.id)),
            "model-value": period,
            "onUpdate:modelValue": 
          updatedPeriod => _ctx.updatePeriod(period, updatedPeriod)
        ,
            disableDelete: _ctx.periods.length === 1
          }, null, 8, ["onRemove", "model-value", "onUpdate:modelValue", "disableDelete"]))
        }), 128))
      ]),
      _: 1
    }, 8, ["options"]),
    _createVNode("button", {
      type: "button",
      class: "button button--add-period",
      onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.addPeriod && _ctx.addPeriod(...args)))
    }, " Add period ")
  ]))
})